<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      table: {
        mname: "consumablesreceive",
        key: "id",
        url: {
          list: "/maintainer/maintainer/consumable/receiveList",
        },
        output: false,
        order: "receiveTime",
      },
      actions: [],
      menus: [],
      filters: [
        {
          label: "领用时间",
          KeyEnter: this.search,
          name: "receiveTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "领用科室",
          name: "desk",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
      ],
      exportdata: [],
      tableCols: [
        {
          title: "领用信息",

          align: "center",
          render: (h, p) => {
            let html = [];
            html.push(
              <div style="float:center">
                <span>{p.row.desk} </span>
                <span>{p.row.receive} </span>
              </div>
            );
            return <div>{html}</div>;
          },
        },
        {
          title: "领用时间",
          width: 150,
          align: "center",
          key: "receiveTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "状态",
          width: 80,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "新订单"
                : row.state === 2
                ? "派送中"
                : row.state === 3
                ? "已完成"
                : "";
            return h(
              "div",
              {
                style: {
                  color: row.state == 1 ? "orange" : row.state == 2 ? "blue" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "完成时间",
          width: 150,
          align: "center",
          key: "finishTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.finishTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              let row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.startChange(currentRow)}
                  type="default"
                  style={{
                    display: row.state === 1 ? "" : "none",
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  开始派送
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.endChange(currentRow)}
                  type="default"
                  style={{
                    display: row.state === 2 ? "" : "none",
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  完成派送
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{ border: "none", color: "#4991ff", marginLeft: "5px" }}
                >
                  详情
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    async startChange(row) {
      let q = {};
      q.id = row.id;
      let res = await $utils.api.load(
        "/maintainer/maintainer/consumable/startConsumable",
        q,
        "post"
      );
      if (res) {
        $utils.toast.success(res.message);
        this.search();
      }
    },
    async endChange(row) {
      let q = {};
      q.id = row.id;
      let res = await $utils.api.load(
        "/maintainer/maintainer/consumable/endConsumable",
        q,
        "post"
      );
      if (res) {
        $utils.toast.success(res.message);
        this.search();
      }
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "recordInfo_weixiu",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/maintainer/maintainer/desk/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.deskName;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "desk") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
  },
};
</script>
<style scoped></style>
